module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "参数名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注说明"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('router-link', {
          staticClass: "btn-link edit-btn",
          attrs: {
            "to": {
              name: 'dictionaryEdit',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_vm._v("编辑")])])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSetting.limit,
      "current-page": _vm.pageSetting.page,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61319e25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/system/dictionary/list.vue
// module id = 1885
// module chunks = 2